(() => {
  const namespace = 'KaratiHeaderCustom';
  const searchInputSelector = [
    '.header-shop-all-search-wrapper input[type="search"]',
    '.header-shop-all-menu-search-wrapper input[type="search"]',
    '.header-shop-all-search-wrapper .search__input',
    '.header-shop-all-menu-search-wrapper .search__input',
  ].join(',');

  const customizeSearch = () => {
    document.querySelectorAll(searchInputSelector).forEach((input) => {
      input.setAttribute('placeholder', 'Buscar producto..');
      input.setAttribute('aria-label', 'Buscar producto..');

      const field = input.closest('.field, .search');
      const label = field ? field.querySelector('.field__label, label') : null;
      if (label) label.textContent = 'Buscar producto..';
    });
  };

  const placeWhatsappButtons = () => {
    document.querySelectorAll('.header').forEach((header) => {
      const whatsappButton = header.querySelector('.header-whatsapp-button');
      if (!whatsappButton) return;

      const cartButton = header.querySelector(
        '.header__icon--cart, #cart-icon-bubble, a[href$="/cart"], a[href*="/cart"]'
      );
      if (!cartButton || cartButton === whatsappButton) return;

      const cartContainer = cartButton.closest('.header-cart') || cartButton;
      if (cartContainer.nextElementSibling !== whatsappButton) {
        cartContainer.insertAdjacentElement('afterend', whatsappButton);
      }
      whatsappButton.classList.add('header-whatsapp-button--inline');
    });
  };

  const positionTabletMenuButtons = () => {
    const isTablet = window.matchMedia('(min-width: 990px) and (max-width: 1199px)').matches;

    document.querySelectorAll('.header').forEach((header) => {
      const drawer = header.querySelector('header-drawer');
      const row = drawer?.closest(
        '.header-row-inner--main, .header-row-inner--medium-main, .header-row-inner--small-main'
      );
      if (!drawer || !row) return;

      if (!isTablet) {
        row.style.removeProperty('--karati-tablet-menu-left');
        row.style.removeProperty('--karati-tablet-menu-top');
        return;
      }

      const search = row.querySelector(
        '.header-shop-all-search-wrapper, .header-shop-all-menu-search-wrapper'
      );
      const buttons = row.querySelector('.header-buttons-wrapper, .header-buttons--acc-cart');
      if (!search || !buttons) return;

      const rowRect = row.getBoundingClientRect();
      const searchRect = search.getBoundingClientRect();
      const buttonsRect = buttons.getBoundingClientRect();
      const menuSize = 40;
      const gap = 8;
      const desiredLeft = searchRect.right - rowRect.left + gap;
      const maximumLeft = buttonsRect.left - rowRect.left - menuSize - gap;
      const left = Math.max(searchRect.left - rowRect.left, Math.min(desiredLeft, maximumLeft));
      const top = searchRect.top - rowRect.top + searchRect.height / 2;

      row.style.setProperty('--karati-tablet-menu-left', `${Math.round(left)}px`);
      row.style.setProperty('--karati-tablet-menu-top', `${Math.round(top)}px`);
    });
  };

  let tabletPositionFrame;
  const scheduleTabletMenuPosition = () => {
    window.cancelAnimationFrame(tabletPositionFrame);
    tabletPositionFrame = window.requestAnimationFrame(positionTabletMenuButtons);
  };

  const init = () => {
    customizeSearch();
    placeWhatsappButtons();
    scheduleTabletMenuPosition();
  };

  if (window[namespace]) {
    window[namespace].init();
    return;
  }

  window[namespace] = { init };
  window.addEventListener('resize', scheduleTabletMenuPosition, { passive: true });
  window.addEventListener('orientationchange', scheduleTabletMenuPosition, { passive: true });
  document.addEventListener('shopify:section:load', init);
  init();
})();
